<script>
import Button from '../components/Button.vue';
import Card from '../components/Card.vue';
import Chip from '../components/Chip.vue';
import MessageDataProvider from '../components/data-provider/MessageDataProvider.vue';
import { OtTooltip, OtTooltipContent, OtTooltipTrigger } from '../components/tooltip';
import MessageRepository from '../domain/message/MessageRepository';

export default {
    components: {
        OtMessageDataProvider: MessageDataProvider,
        OtCard: Card,
        OtButton: Button,
        OtChip: Chip,
        OtTooltip,
        OtTooltipContent,
        OtTooltipTrigger,
    },
    methods: {
        trash(message, reload) {
            new MessageRepository()
                .updateStatus(message.getId(), 'trashed')
                .then(() => reload());
        },
    },
};
</script>

<template>
    <ot-card>
        <ot-message-data-provider v-slot="{ data: messages, reload }" method="findAll" :params="{ type: 'inbox' }" collection>
            <ul style="padding-left: 0!important;" class="divide-y divide-gray-400">
                <li v-for="message in messages" :key="message.getId()">
                    <router-link :to="`/message/${message.getId()}`" class="flex justify-between items-center p-4 hover:bg-gray-400">
                        <div>
                            <div>
                                <ot-tooltip>
                                    <ot-tooltip-trigger>{{ message.getTitle() }}</ot-tooltip-trigger>
                                    <ot-tooltip-content side="bottom" class="whitespace-pre-wrap">{{ message.getContent() }}</ot-tooltip-content>
                                </ot-tooltip>
                                <ot-chip v-if="message.getStatus() === 'new'" type="red" small class="ml-1">{{ $t('nachrichten.unread') }}</ot-chip>
                            </div>
                            <div class="text-xs">
                                <span>{{ message.getFormattedDate() }}</span>
                                &mdash;
                                <template v-if="message.isSystemMessage()">Onlinetennis</template>
                                <template v-if="!message.isSystemMessage()"><a :href="`#/player/${message.getSenderId()}`">{{ message.getSenderName().getFullName() }}</a></template>
                            </div>
                        </div>
                        <ot-button variant="danger" @click.prevent="trash(message, reload)">{{ $t('nachrichten.nachrichten_loeschen') }}</ot-button>
                    </router-link>
                </li>
            </ul>
        </ot-message-data-provider>
    </ot-card>
</template>
